import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { FormGroup, Input, Label } from 'reactstrap';
import { ForgotPassword, RememberPassword } from '../../../Constant';

const FormPassword = () => {
    return (
        <Fragment>
            <FormGroup className="mb-0 position-relative">
                <div className="checkbox">
                    <Input id="checkbox1" type="checkbox" />
                    <Label className="text-muted" htmlFor="checkbox1">{RememberPassword}</Label>
                    <Link className="link" to={`${process.env.PUBLIC_URL || ''}/password-recovery`}>{ForgotPassword}</Link>
                </div>
            </FormGroup>
        </Fragment>
    );
};
export default FormPassword;